import { DashboardIndexComponent } from "../components/dashboard/DashboardIndexComponent";
import { useFetchDashboardHealth } from "../hooks/dashboard/useFetchDashboardHealth";
import { useReturnGeneralInformation } from "../hooks/global/useReturnGeneralInformation";

const resolveFirstName = (generalInfo: unknown): string | null => {
  if (!generalInfo) return null;

  try {
    const parsed = typeof generalInfo === "string" ? JSON.parse(generalInfo) : generalInfo;
    return (parsed as { first_name?: string }).first_name ?? null;
  } catch {
    return null;
  }
};

export const DashboardPage = () => {
  const dashboardHealth = useFetchDashboardHealth();
  const generalInfo = useReturnGeneralInformation();

  return (
    <DashboardIndexComponent
      {...dashboardHealth}
      firstName={resolveFirstName(generalInfo)}
    />
  );
};
